import { getTenant } from "@/TENANT_CONFIGS";

/**
 * MAD's data, as the MAD custom widgets read it. One place for the paths so
 * the Child Progress charts and the assessment-completion table never
 * disagree about where a child, a volunteer or an assessment number lives.
 *
 * Everything here is MAD's own templates, so every widget that imports this
 * gates itself with `isMadTenant()` and is offered nowhere else.
 */
export const TENANT = "mad";
export const isMadTenant = () => getTenant() === TENANT;

/** The assessment cycle, in order. `display` is what axes and headers show. */
export const ASSESSMENTS = [
  { value: "baseline", display: "Baseline" },
  { value: "midline1", display: "Midline 1" },
  { value: "midline2", display: "Midline 2" },
  { value: "midline3", display: "Midline 3" },
  { value: "endline", display: "Endline" },
];

export const VOLUNTEER_TAG_TYPE = "volunteers";

/**
 * A doc's MAD centre: the doc is tagged with a volunteer, the volunteer's
 * profile is tagged with a centre. The rollup path both the dashboard's
 * centre filter and the centre chart's dimension walk.
 */
export const CENTRE_ROLLUP_PATH = ["volunteers", "mADCentres"];

/**
 * The templates that hold one doc per (volunteer, child, assessment), and
 * where in each doc the child (id + name), the assessment number and the
 * assessment grade (the recorded "Final Learning grade level" — not the
 * child's actual grade) sit. Life Skills records no assessment grade.
 */
export const DATASETS = {
  baselineAssessments: {
    label: "Numeracy",
    childValuePath: "main.ouj84t.value",
    childDisplayPath: "main.ouj84t.display",
    assessmentValuePath: "main.baselineAssessments_assessmentNumber.value",
    levelValuePath: "main.baselineAssessments_finalLearningGradeLevel_v1",
  },
  baselineAssessmentsFoundationalLiteracyP: {
    label: "Literacy",
    childValuePath: "main.mdyfzc.value",
    childDisplayPath: "main.mdyfzc.display",
    assessmentValuePath: "main.baselineAssessmentsFoundationalLiteracyP_assessmentNumber.value",
    levelValuePath: "main.baselineAssessmentsFoundationalLiteracyP_finalLearningGradeLevel_v1",
  },
  baselineAssessmentsFoundationalLifeSkill: {
    label: "Life Skills",
    childValuePath: "main.baselineAssessmentsFoundationalLifeSkill_childName.value",
    childDisplayPath: "main.baselineAssessmentsFoundationalLifeSkill_childName.display",
    assessmentValuePath: "main.baselineAssessmentsFoundationalLifeSkill_assessmentNumber.value",
  },
};

/**
 * The roster of children: MAD's own allocation feed, every active
 * (volunteer, child) allocation in one call. Nothing is stored on our side —
 * the same feed the assessment forms' Child Name dropdown reads per
 * volunteer (getChildrenByVolunteer), served whole by getAllChildren.
 * Each row: { display, value: child id, volunteer: { madId, display } }.
 */
export const ROSTER_ENDPOINT = "/api/pluginRoutes/mad/getAllChildren";

/**
 * Per MAD centre with a CO / CHO: organisers, children, and how many have
 * baseline assessments / cleared the ASER baselines — computed server-side
 * from the profiles, MAD's feed and the three templates (getCentreCoverage).
 */
export const CENTRE_COVERAGE_ENDPOINT = "/api/pluginRoutes/mad/getCentreCoverage";
